import { createContext, ReactNode, useContext, useState } from 'react';

interface ToasterContextProps {
  toasterDrawerIsOpen: boolean;
  setToasterDrawerIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toasterNotificationsIsOpen: boolean;
  setToasterNotificationsIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ToasterProviderProps {
  children: ReactNode;
}

const ToasterContext = createContext<ToasterContextProps>({
  toasterDrawerIsOpen: false,
  setToasterDrawerIsOpen: undefined,
  toasterNotificationsIsOpen: false,
  setToasterNotificationsIsOpen: undefined,
});

export const ToasterProvider = ({ children }: ToasterProviderProps) => {
  const [toasterDrawerIsOpen, setToasterDrawerIsOpen] = useState(false);
  const [toasterNotificationsIsOpen, setToasterNotificationsIsOpen] = useState(false);

  return (
    <ToasterContext.Provider
      value={{
        toasterDrawerIsOpen,
        setToasterDrawerIsOpen,
        toasterNotificationsIsOpen,
        setToasterNotificationsIsOpen,
      }}
    >
      {children}
    </ToasterContext.Provider>
  );
};

export const useToasterContext: () => ToasterContextProps = () => {
  return useContext(ToasterContext);
};
